'use strict';

import React from 'react';
import {FluxMixin} from 'fluxxor';
import _ from 'underscore';
import $ from 'jquery';


var ModalMixin = {
  mixins: [
    FluxMixin(React)
  ],

  getInitialState() {
    return {
      loaded: false,
      style: {}
    };
  },

  handleClose() {
    this.setState({loaded: false});
    this.close();
  },

  componentWillUnmount() {
    $(window).off('resize.modal- ' + this._rootNodeID);
  },

  componentDidMount() {
    this.setPosition();
    this.setState({loaded: true});
    $(window).on('resize.modal-' + this._rootNodeID, this.setPosition);
  },

  close() {
    this.getFlux().actions.layers.remove();
  },

  killClick(e) {
    e.stopPropagation();
  },

  setPosition() {
    var $el = $(this.getDOMNode());
    var $modal = $el.find('.react-modal');
    var offset = 40;

    var style = this.state.style;

    if ($modal.css('position') === 'relative') {
      style['top'] = $(window).scrollTop() + offset + 'px';
    } else {
      style['top'] = 0;
    }
    this.setState({style});
  }
};

export default ModalMixin;



/** WEBPACK FOOTER **
 ** ./static/js/onefinestay/components/layers/ModalMixin.jsx
 **/